import { useMemo } from 'react';

import Button from '@/components/Button';
import { searchPanelCtaDataLayerEvent } from '@/v2/components/pages/PackageView/utils/dataLayer/dataLayer';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import dataLayer from '@/v2/utils/dataLayer';

export type CtaButtonProps = {
  hasSelection: boolean;
  onReserve: () => void;
  onCheckAvailability: () => void;
  isDisabled?: boolean;
};

const CtaButton = ({
  hasSelection,
  onReserve,
  onCheckAvailability,
  isDisabled,
}: CtaButtonProps) => {
  const shouldUseNewEvents = useGA4Events();

  const { onClick, text } = useMemo(() => {
    if (hasSelection) {
      return {
        text: 'Reserve',
        onClick: onReserve,
      };
    }

    return {
      text: 'Check availability',
      onClick: onCheckAvailability,
    };
  }, [hasSelection, onCheckAvailability, onReserve]);

  const handleClick = () => {
    searchPanelCtaDataLayerEvent({ action: text });
    onClick();
    if (shouldUseNewEvents) {
      dataLayer.ctaClickEvent({
        itemText: text,
      });
    }
  };

  return (
    <Button
      data-testid="CTA_BUTTON"
      variant="primary"
      onClick={handleClick}
      disabled={isDisabled}
    >
      {text}
    </Button>
  );
};

export default CtaButton;
